export const DASHBOARD_ALLOWED_USERNAMES = ['ngy', '十二'];
export const ORDER_EDIT_ALLOWED_USER_IDS = [30, 32, 35];
export const SOFTWARE_USAGE_ALLOWED_USERNAMES = ['汤圆', '格子', 'zzn', '管理员', 'ngy'];

export const canViewDashboard = (user) => {
  if (!user) return false;

  const role = String(user.role || '').trim().toLowerCase();
  const username = String(user.username || '').trim();

  return role === 'admin' || DASHBOARD_ALLOWED_USERNAMES.includes(username);
};

export const canViewSoftwareUsage = (user) => {
  if (!user) return false;
  const role = String(user.role || '').trim().toLowerCase();
  const username = String(user.username || '').trim().toLowerCase();
  return role === 'admin' || SOFTWARE_USAGE_ALLOWED_USERNAMES.some(
    (allowed) => allowed.toLowerCase() === username,
  );
};

export const canEditOrders = (user) => {
  if (!user) return false;

  const role = String(user.role || '').trim().toLowerCase();
  const userId = Number(user.id);

  return role === 'admin' || ORDER_EDIT_ALLOWED_USER_IDS.includes(userId);
};

export const canDeletePlaceOrders = (user) => {
  if (!user) return false;

  const role = String(user.role || '').trim().toLowerCase();
  const userId = Number(user.id);

  return role === 'admin'
    || role === 'service'
    || role === '客服'
    || ORDER_EDIT_ALLOWED_USER_IDS.includes(userId);
};

export const getDefaultHomePath = (user) => (
  canViewDashboard(user) ? '/dashboard' : '/order-fill'
);
